module.exports = __webpack_public_path__ + "static/images/93d6acc36f4de36700c5161641e8f434.webp";